import { showLoading, hideLoading } from 'react-redux-loading-bar'
import BooksActions from './actions'
import { addNotification as notify } from 'reapop'
import request from './../../utils/requestConfig'
import {paramsWarningNotify} from '../../utils/notifyConfig'

export default class BooksMiddleware {
  static fetchBooks () {
    return (dispatch, getState) => {
      const { paginate, searchTerm, filter } = getState().books
      const { page, perPage } = paginate
      const {
        segments,
        subjects,
        authors,
        publishers,
        intelligenceScopes,
        onuGroups,
        onuGoals,
        twentyfirstCompetences,
        twentyfirstSkills,
        oostSubjects,
        sels
       } = filter
      dispatch(showLoading())
      dispatch(BooksActions.fetchBooksRequest())
      request.get('/products/search', {
        params: {
          per: perPage,
          page: page,
          terms: searchTerm,
          education_segment_ids: segments.toString(),
          education_subject_ids: subjects.toString(),
          book_publisher_ids: publishers.toString(),
          book_author_ids: authors.toString(),
          with_active_products: 'true',
          education_intelligence_scope_ids: intelligenceScopes.toString(),
          education_onu_group_ids: onuGroups.toString(),
          education_onu_goal_ids: onuGoals.toString(),
          education_twentyfirst_competence_ids: twentyfirstCompetences.toString(),
          education_twentyfirst_skill_ids: twentyfirstSkills.toString(),
          education_oost_subject_ids: oostSubjects.toString(),
          education_sel_ids: sels.toString()
        }
      })
        .then(({data, headers}) => {
          dispatch(BooksActions.fetchBooksSuccess({ data: data.data, totalCount: headers['x-total-count'] }))
          dispatch(hideLoading())
        })
        .catch((error) => {
          dispatch(BooksActions.fetchBooksError(error))
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar os livros!',
            status: error.response.status
          }))
        })
    }
  }
  static modalBooksToggleView () {
    return (dispatch) => {
      dispatch(BooksActions.ModalToggleView())
    }
  }
  static changeSearchTerm (searchTerm) {
    return (dispatch) => {
      dispatch(BooksMiddleware.changeActivePage(1))
      dispatch(BooksActions.ModalChangeSearchTerm(searchTerm))
      dispatch(BooksMiddleware.fetchBooks())
    }
  }
  static resetSearchTerm () {
    return (dispatch) => {
      dispatch(BooksActions.ModalChangeSearchTerm(''))
      dispatch(BooksMiddleware.changeActivePage(1))
    }
  }
  static changeActivePage (page) {
    return (dispatch) => {
      dispatch(BooksActions.ModalChangeActivePage(page))
    }
  }
  static changePageCount (total) {
    return (dispatch) => {
      dispatch(BooksActions.ModalChangePageCount(total))
    }
  }
  static changeFilter (type, activeIds) {
    return (dispatch) => {
      dispatch(BooksActions.ModalChangeFilter({type, activeIds}))
      dispatch(BooksMiddleware.changeActivePage(1))
      dispatch(BooksMiddleware.fetchBooks())
    }
  }
  static resetFilter () {
    return (dispatch) => {
      dispatch(BooksActions.resetBookFilter())
      dispatch(BooksMiddleware.changeActivePage(1))
      dispatch(BooksMiddleware.fetchBooks())
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/books/middleware.js